import React from 'react';
import './intro.css'
import {Link} from 'react-scroll';
import AbhashImage from '../../resources/AbhashBackgroundNew.png'
import ContactMe from '../../resources/briefcase.png'

const Intro = () => {
    return (
        <section id="intro">
            <div className="introContent">
                <span className="hello">Hey There, </span>
                <span className="introText">It's me 
                    <span className="introName"> Abhash Rajbhandari</span> 
                    <br /> Computer Engineer 
                </span>
                <p className="introPara">A highly motivated Full-Stack Software Engineer with 10 years of experience <br></br> crafting innovative solutions in the software development industry with <br></br> proven ability to lead, take ownership, and deliver well-architected projects, <br></br> ensuring their long-term success.</p>
                
                
                <Link>
                    <button className="btn" onClick={() => {
                    document.getElementById('contact').scrollIntoView({behavior: 'smooth'})
                    }}><img src={ContactMe} alt="Hire Me" className='btnImg'/>Hire Me</button>
                </Link>

            </div>

            //Abhash ko photo yeta jancha
            <img src={AbhashImage} alt="Profile" className="background" />

        </section>

    )
}

export default Intro